import _Menu from "material-ui/Menu";
import _MenuItem from "material-ui/MenuItem";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Popover, PopoverAnimationVertical } from 'material-ui/Popover';
import { getFilter } from 'swag-client-common/utils/tricks';
import { variables } from 'swag-client-common/styles/variables-js';
import { handleOnEscapePressed } from 'swag-client-common/utils/ui.utils';
import { styles } from '../products-sorting/popover-settings';
export const ProductsSortingOptionsComponent = ({
  sorting,
  isOpen,
  anchorEl,
  onRequestClose,
  onChange,
  targetOrigin,
  anchorOrigin,
  secondaryColor,
  sortingOptions,
  handleMenuClose
}) => {
  _extends(styles.selectedItem, {
    backgroundColor: secondaryColor || variables.colorAlternativePrimary
  });
  const onClose = () => {
    onRequestClose();
    handleMenuClose === null || handleMenuClose === void 0 ? void 0 : handleMenuClose();
  };
  const handleKeyDown = event => {
    handleOnEscapePressed(event, onClose);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Popover, {
    open: isOpen,
    anchorEl: anchorEl,
    anchorOrigin: anchorOrigin,
    targetOrigin: targetOrigin,
    onRequestClose: onRequestClose,
    animation: PopoverAnimationVertical
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Menu, {
    onChange: onChange,
    selectedMenuItemStyle: styles.selectedItem,
    value: sorting,
    onKeyDown: handleKeyDown
  }, sortingOptions.map(({
    name,
    isForClient
  }) => /*#__PURE__*/React.createElement(_MenuItem, {
    primaryText: getFilter(name, isForClient),
    value: name,
    style: sorting === name ? styles.selectedItem : styles.menuItem
  }))))));
};